export function formatPrice(value: number): string {
  return `$ ${value.toLocaleString('es-UY', { maximumFractionDigits: 0 })}`
}

export function stockLabel(stock: number): {
  label: string
  dot: string
  text: string
} {
  if (stock === 0) {
    return { label: 'Sin stock', dot: 'bg-neutral-500', text: 'text-neutral-500' }
  }
  if (stock <= 8) {
    return { label: 'Poco stock', dot: 'bg-red-500', text: 'text-red-400' }
  }
  return { label: 'Disponible', dot: 'bg-emerald-500', text: 'text-emerald-400' }
}
